module.exports = __webpack_public_path__ + "img/cover_storageboxSero.09d337d7.png";